import React from "react";
import { Box, Typography, TextField, Stack } from "@mui/material";
import {
  formatPhoneNumber,
  isValidName,
  isValidPhone,
} from "../../../utils/validation"; // Adjust path if needed

const EditableCustomerInfo = ({ order, setOrder }) => {
  const customer = order.customer || {};

  const handleChange = (field, value) => {
    setOrder({
      ...order,
      customer: { ...order.customer, [field]: value },
    });
  };

  const handleNameChange = (field) => (e) => {
    const value = e.target.value;
    if (value === "" || isValidName(value)) {
      handleChange(field, value);
    }
  };

  const handlePhoneChange = (e) => {
    const raw = e.target.value;
    const formatted = formatPhoneNumber(raw);
    handleChange("phone", formatted);
  };

  return (
    <Box p={2}>
      <Typography variant="h6" gutterBottom>
        Customer Info
      </Typography>

      <Stack spacing={2} mt={2}>
        <TextField
          label="First Name"
          fullWidth
          value={customer.firstName || ""}
          onChange={handleNameChange("firstName")}
        />

        <TextField
          label="Last Name"
          fullWidth
          value={customer.lastName || ""}
          onChange={handleNameChange("lastName")}
        />

        <TextField
          label="Email"
          fullWidth
          value={customer.email || ""}
          disabled // ❌ Make read-only
        />

        <TextField
          label="Phone"
          fullWidth
          value={customer.phone || ""}
          onChange={handlePhoneChange}
          error={!!customer.phone && !isValidPhone(customer.phone)}
          helperText={
            customer.phone && !isValidPhone(customer.phone)
              ? "Phone number must be 10 digits"
              : ""
          }
        />
      </Stack>
    </Box>
  );
};

export default EditableCustomerInfo;
